export default "__VITE_ASSET__C2_PcI0r__"